import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorMasterBankList = () => {
  const listBank = useCallback((callback, payload, loadingCallback) => {
    ApiService.jsonRequest('/master-bank/list', payload, (response) => {
      if (response.status_code === 200) {
        callback(response.data)
      }
      loadingCallback(false)
    })
  }, [])

  return { listBank }
}

export default InteractorMasterBankList
